export default class GameConfig {
    static json: any;

    static loadConfigFile(cache: Phaser.Cache.CacheManager, key: string): void {
        this.json = cache.json.get(key);
    }

    static get<T>(id: string): T {
        if (this.json === undefined) throw new Error("Config file not loaded");
        if (this.json[id] === undefined) throw new Error("Key '" + id + "' does not exist in config file");

        return this.json[id];
    }
}
